import React from 'react';
import RichTextEditor from 'react-rte';
import { withStyles, Typography } from './../../../../themes/default';
import { FormControl  } from './../../../../themes/input';

const styles = theme => ({
  root: {
    borderRadius: theme.spacing.unit / 2,
    border: `1px solid ${ theme.palette.grey[200] }`,
    '& > div > div': {
      border: 'none'
    }
  },
  label: {
    fontWeight: 600,
    marginLeft: 12,
    marginRight: 12,
    marginTop: 10
  }
});

class RichTextMarkdown extends React.Component {

  constructor(props){
    super(props);
    this.state = {
      value: this.props.input.value === '' ?
                RichTextEditor.createEmptyValue() :
                RichTextEditor.createValueFromString(this.props.input.value, 'html')
    };

  }

  componentWillReceiveProps(nextProps) {
      if (nextProps.input.value !== this.state.value.toString('html')) {
          this.setState({
              value: nextProps.input.value ?
                  RichTextEditor.createValueFromString(nextProps.input.value, 'html') :
                  RichTextEditor.createEmptyValue()
          });
      }
  }

  onChange(value) {
      const isTextChanged = this.state.value.toString('html') !== value.toString('html');
      this.setState({value}, e => isTextChanged && this.props.input.onChange(value.toString('html')));
  };

  render() {

    const { required, label, classes } = this.props;
    const { touched, error, warning } = this.props.meta;

    return (
      <div className={ classes.root }>
        <FormControl fullWidth>
          { label && (
            <Typography variant="caption" color="primary" component="label" className={ classes.label }>{ label }</Typography>
          )}
          <RichTextEditor value={this.state.value} onChange={this.onChange.bind(this)} required={ required ? true : false }/>
          {touched && ((error && <span>{error}</span>) || (warning && <span>{warning}</span>))}
        </FormControl>
      </div>
    )

  }

}

export default withStyles(styles)(RichTextMarkdown);
